import { IndexKvSlider } from './IndexKvSlider'
export class Loading {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      const body = document.body
      if (!body.classList.contains('home')) return false
      const flg = sessionStorage.getItem('loading')
      const loading = document.querySelector('.js-loading')
      const kv = document.getElementById('js-index_kv')
      const header = document.getElementById('js-header')
      if (loading === null) return
      if (flg) {
        new IndexKvSlider()
        loading.classList.add('is-hide')
        setTimeout(() => {
          kv.classList.add('is-view')
        }, 1000)
        setTimeout(() => {
          header.classList.add('is-view')
        }, 1500)
      } else {
        const title = document.querySelector('.js-loading_title')

        body.classList.add('is-act')
        setTimeout(() => {
          title.classList.add('is-act')
          loading.classList.add('is-act')
        }, 1000)
        setTimeout(() => {
          loading.classList.add('is-hide')
          kv.classList.add('is-view')
          header.classList.add('is-view')
          new IndexKvSlider()
          body.classList.remove('is-act')
        }, 3000)
        sessionStorage.setItem('loading', true)
      }
    })
  }
}
